export const helpCommand = (setMessages) => {
    const helpMessage = {
        id: Date.now() + Math.random(),
        sender: "ai",
        text: [
            "Available commands:",
            "",
            "/help - Show this help message",
            "/clear - Clear the chat history",
            "/chuck - Get a random Chuck Norris fact",
            "",
            "Easter Eggs:",
            "> Remember that telnet command from windows 95? The one about the force..",
            "> Something may happen if you try the chuck command..",
        ].join('\n'),
        displayText: "",
    };

    setMessages(prev => [...prev, helpMessage]);
    return true;
}; 